/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinalizeUploadRequest } from '../models/FinalizeUploadRequest';
import type { SearchVideoSchema } from '../models/SearchVideoSchema';
import type { VideoDetailResponse } from '../models/VideoDetailResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class VideosService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Upload video file
     * Upload the actual video file to R2 storage
     * @returns any Upload successful
     * @throws ApiError
     */
    public postVideosUpload({
        id,
        formData,
    }: {
        id: string,
        formData?: {
            file?: Blob;
        },
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/videos/{id}/upload',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Upload a thumbnail image for a video
     * Upload a thumbnail image (JPG/PNG) for a video you own or uploaded.
     * @returns any Thumbnail uploaded successfully
     * @throws ApiError
     */
    public postVideosThumbnail({
        id,
        formData,
    }: {
        id: string,
        formData?: {
            file?: Blob;
        },
    }): CancelablePromise<{
        message: string;
        thumbnailR2Key: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/videos/{id}/thumbnail',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `No file provided`,
                403: `Forbidden`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Get video thumbnail image
     * Stream the thumbnail image for a video you have access to.
     * @returns any Thumbnail image stream
     * @throws ApiError
     */
    public getVideosThumbnail({
        id,
        token,
    }: {
        id: string,
        token?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/videos/{id}/thumbnail',
            path: {
                'id': id,
            },
            query: {
                'token': token,
            },
            errors: {
                403: `Forbidden`,
                404: `Thumbnail not found`,
            },
        });
    }

    /**
     * Finalize video upload
     * Mark the video upload as complete and set metadata
     * @returns VideoDetailResponse Upload finalized successfully
     * @throws ApiError
     */
    public postVideosFinalize({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: FinalizeUploadRequest,
    }): CancelablePromise<VideoDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/videos/{id}/finalize',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Embedded videos do not require finalization`,
                403: `Forbidden - insufficient permissions`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Get video metadata
     * Get generic playback metadata for any video (upload or embed), regardless of whether it belongs to an exercise or a completion recording.
     * @returns VideoDetailResponse Video metadata
     * @throws ApiError
     */
    public getVideos({
        id,
    }: {
        id: string,
    }): CancelablePromise<VideoDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/videos/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden - insufficient permissions`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Stream video
     * Stream the video file from R2 storage
     * @returns any Video stream
     * @throws ApiError
     */
    public getVideosStream({
        id,
        token,
    }: {
        id: string,
        token?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/videos/{id}/stream',
            path: {
                'id': id,
            },
            query: {
                'token': token,
            },
            errors: {
                400: `Video upload not complete`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Search videos
     * Search for online videos (YouTube, etc.) using Brave Video Search.
     * @returns SearchVideoSchema Video search results
     * @throws ApiError
     */
    public getVideosVideoSearch({
        q,
        count,
        offset,
    }: {
        q: string,
        count?: number,
        offset?: number | null,
    }): CancelablePromise<SearchVideoSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/videos/video/search',
            query: {
                'q': q,
                'count': count,
                'offset': offset,
            },
            errors: {
                403: `Forbidden`,
            },
        });
    }

}
